module.exports = {
  CLIENT_ENV: 'real',
  BASE_URL: 'https://api.linebank.co.id',
  APP_SCHEME: 'lbid://', // TODO(fe): beta에 real 옵션으로 빌드되기 때문에 open 전에 lbid로 변경
  //ASSET_PATH: 'https://hybrid.linebank.co.id/', // TODO: Real Static Resource 주소 확인
  LINE_PROFILE_URL:
    'https://sprofile.line-scdn.net https://profile.line-scdn.net https://static.linebank.co.id',
  APP_LINK: 'https://hybrid.linebank.co.id/',
}
